import {get} from 'lodash'
import createModel from 'utils/model'
import {
    taskGroupChat,
    updateTaskGroupChat,
    removeTaskGroupChat,
} from 'crm/services/tag-create-group'

export default createModel({
    namespace: 'crm_tagCreateGroupChat',

    state: {
        tableData: {},
    },

    effects: {
        *taskGroupChat({payload}, {select, put, call}) {
            const {tableData} = yield select(({crm_tagCreateGroupChat}) => crm_tagCreateGroupChat)

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            const res = yield call(taskGroupChat, {id: payload.id, params: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = get(res, 'pagination.rows_found', 0)
                },
            })
        },
        *updateTaskGroupChat({payload}, {call}) {
            return yield call(updateTaskGroupChat, payload)
        },
        *removeTaskGroupChat({payload}, {call}) {
            return yield call(removeTaskGroupChat, payload)
        },
    },
    reducers: {},
})
